// extracted by mini-css-extract-plugin
export var attachmentContainer = "_fg-0";
export var fileList = "_fg-2";
export var removeFileButton = "_fg-1";